import { useCallback } from 'react'

import { axiosClient } from '../../../../services/axiosInstance'

interface FreightAddress {
  street: string
  number: string
  neighborhood: string
  city: string
  state: string
  country: string
  geoCoordinates: number[]
  complement: string
  postalCode: string
}

export interface FreightPickupPoint {
  address: FreightAddress
  distance: string
  name: string
  price: number
  shippingEstimate: string
}

export interface FreightSimulationData {
  packages: Array<{
    seller: string
    deliveryTypes: Array<{
      type: string
      value: number
      shippingEstimate: string
    }>
    pickupPoints: PickupPoint
  }>
}

export interface PickupPoint {
  others: FreightPickupPoint[]
  recommend: FreightPickupPoint[]
}

export interface Item {
  id: string
  seller: string
  quantity: number
}

export function useFreightSimulation() {
  const getFreightSimulation = useCallback(
    async (
      items: Item[],
      cep: string
    ): Promise<FreightSimulationData | undefined> => {
      const body = {
        items,
        postalCode: cep,
        country: 'BRA',
      }

      const response = await axiosClient
        .post<FreightSimulationData>('/api/pdp/simulation', body, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .catch((error) => {
          if (error.response) {
            console.error(
              '[simulation] Server responded with error:',
              error.response.status
            )
          } else if (error.request) {
            console.error('[simulation] No response received:', error.request)
          } else {
            console.error(
              '[simulation] Error setting up the request:',
              error.message
            )
          }
        })

      return response?.data
    },
    []
  )

  return {
    getFreightSimulation,
  }
}
